module.exports = __webpack_public_path__ + "img/clement-shop1.435f4da3.png";